module.exports = __webpack_public_path__ + "img/huawei.b157a622.png";